import React from 'react';
import { CardFormatType, CardSizeType, ContentCardType } from '../../../../../types/decks';
import { ContentCardLandscape } from './ContentCardLandscape';
import { ContentCardMiniHero } from './ContentCardMiniHero';
import type { useActions } from '../../../../../hooks/useActions';

export type CardProps = {
  card: ContentCardType;
  cardSize: CardSizeType;
  cardFormat: CardFormatType;
  actions: ReturnType<typeof useActions>;
};

export function ContentCard(props: CardProps): React.ReactNode {
  switch (props.cardFormat) {
    case 'MINI_HERO':
      return <ContentCardMiniHero {...props} />;
    case 'PORTRAIT':
    case 'LANDSCAPE':
      return <ContentCardLandscape {...props} />;
    default: {
      const _exhaustive: never = props.cardFormat;
      void _exhaustive;
      return <ContentCardLandscape {...props} />;
    }
  }
}
